function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function getCookieContent(cookieName: string): string | null {
  if (typeof document === 'undefined' || !cookieName) {
    return null;
  }
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${escapeRegExp(cookieName)}=([^;]*)`),
  );
  return match?.[1] ?? null;
}

export function getCookieValue(
  content: string,
  key: string,
  delimiter = '&',
): string {
  if (!content || !key) {
    return '';
  }
  const parts = content.split(delimiter);
  const prefix = `${key}=`.toLowerCase();
  const pair = parts.find(part => part.toLowerCase().startsWith(prefix));
  return pair?.slice(prefix.length) ?? '';
}
